import { HYDRATE } from "next-redux-wrapper";
import { ActionsHighlightReview } from "./actions";

const initialState = {
	data: {},
	meta: {},
	is_loading: true,
	error: null,
	status: "fetch_init",
	message: "",
};

function storeHighlightReview(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeHighlightReview };
	case ActionsHighlightReview.LOAD_GET_HIGHLIGHT_REVIEW:
		return {
			...state,
			status: "fetch_loading",
			is_loading: true,
			error: null,
		};
	case ActionsHighlightReview.RES_GET_HIGHLIGHT_REVIEW:
		return {
			...state,
			data: action.data.data,
			meta: action.data.meta,
			status: "fetch_result",
			is_loading: false,
			error: null,
		};
	case ActionsHighlightReview.ERR_GET_HIGHLIGHT_REVIEW:
		return {
			...state,
			data: {},
			meta: {},
			status: "fetch_error",
			message: "Error...",
			is_loading: false,
			error: true,
		};
	default:
		return { ...state };

	}

}

export default storeHighlightReview;
